import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { KycQuestionnaireSendDetailWidget } from "../../widgets/kycQuestionnaire/sendDetail";

export const KycQuestionnaireSendDetailPage = () => {
  const { _id } = useParams<{ _id: string }>();
  useEffect(() => {
    document.title = "Илгээмж дэлгэрэнгүй";
  }, []);
  return (
    <div className="page">
      <KycQuestionnaireSendDetailWidget _id={_id} />
    </div>
  );
};
